

export default function Benefit2() {
	return (
		<>

			<div className="tf-widget-benefit-v2 background-black">
				<div className="themeflat-container">
					<div className="tf-benefit-v2">
						<div className="title-box-v2 center-title-box title-large">
							<span className="sub-title wow fadeInUp animated">running's benefits</span>
							<h2 className="title-section wow fadeInUp animated">PROPLAY Sports Management</h2>
						</div>{/* header style v2 */}
						<div className="row benefit-v2">
							<div className="col-12 col-sm-6 col-md-6 col-lg-3">
								<div className="benefit-item-v2 wow fadeInUp animated" data-wow-delay="0.1s">
									<div className="benefit-number">
										<span className="number">01</span>
									</div>
									<div className="line-benefit" />
									<div className="box-content-benefit">
										<h6 className="title-benefit">Sport & Fitness Academies</h6>
										<p className="description-benefit">Improve cardiovascular fitness, build strength, and boost
											overall well-being through regular running sessions.</p>
									</div>
								</div>
							</div>
							<div className="col-12 col-sm-6 col-md-6 col-lg-3">
								<div className="benefit-item-v2 wow fadeInUp animated" data-wow-delay="0.3s">
									<div className="benefit-number">
										<span className="number">02</span>
									</div>
									<div className="line-benefit" />
									<div className="box-content-benefit">
										<h6 className="title-benefit">Multi Sport Venue Operations</h6>
										<p className="description-benefit">Improve cardiovascular fitness, build strength, and boost
											overall well-being through regular running sessions.</p>
									</div>
								</div>
							</div>
							<div className="col-12 col-sm-6 col-md-6 col-lg-3">
								<div className="benefit-item-v2 wow fadeInUp animated" data-wow-delay="0.5s">
									<div className="benefit-number">
										<span className="number">03</span>
									</div>
									<div className="line-benefit" />
									<div className="box-content-benefit">
										<h6 className="title-benefit">Schools/Corporate Collaborations</h6>
										<p className="description-benefit">Improve cardiovascular fitness, build strength, and boost
											overall well-being through regular running sessions.</p>
									</div>
								</div>
							</div>
							<div className="col-12 col-sm-6 col-md-6 col-lg-3">
								<div className="benefit-item-v2 wow fadeInUp animated" data-wow-delay="0.7s">
									<div className="benefit-number">
										<span className="number">04</span>
									</div>
									<div className="line-benefit" />
									<div className="box-content-benefit">
										<h6 className="title-benefit">Hoasting of Multi Sport Event </h6>
										<p className="description-benefit">Improve cardiovascular fitness, build strength, and boost
											overall well-being through regular running sessions.</p>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</>
	)
}
